<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-progress-linear
        indeterminate
        :active="isRequestingNow.length > 0"
        color="blue"
        class="mb-0"
      ></v-progress-linear>
      <v-overlay :value="pageLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-flex v-if="item" style="position: relative">
        <v-container class="grey lighten-5">
          <v-form
            ref="form"
            autocomplete="off"
            method="post"
            action=""
          >
            <v-row no-gutters class="pagination-table-header">
              <v-col
                v-if="regionsItems"
                cols="12"
                md="6">
                <v-select
                  v-model="item.region"
                  :hint="$t('hints.region')"
                  :items="regionsItems"
                  persistent-hint
                  single-line
                  @change="updateRequest('region', $event)"
                  :loading="false"
                ></v-select>
              </v-col>
            </v-row>
            <v-row no-gutters class="pagination-table-header">
              <v-col
                cols="12"
                sm="5"
                class="py-md-0"
              >
                <v-text-field
                  :disabled="pageLoading"
                  v-model="item.name"
                  :counter="200"
                  :rules="[rules.required, rules.max(200)]"
                  prepend-icon="mdi-tooltip-text-outline"
                  :label="$t('general.title')"
                  autocomplete="off"
                  :error-messages="(errors && errors.name)?errors.name:null"
                  @input="removeError('name')"
                  @change="updateRequest('name', $event)"
                  :loading="isRequestingNow.includes('name')"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="2"
                class="py-md-0"
              >
                <v-select
                  v-model="item.measure"
                  :items="measureItems"
                  persistent-hint
                  single-line
                  @change="removeError('measure'); updateRequest('measure', $event)"
                  :loading="isRequestingNow.includes('measure')"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="5"
                class="py-md-0"
              >
                <v-text-field
                  :disabled="pageLoading"
                  v-model="item.note"
                  :counter="200"
                  :rules="[rules.max(200)]"
                  prepend-icon="mdi-tooltip-text-outline"
                  :label="$t('general.note')"
                  autocomplete="off"
                  :error-messages="(errors && errors.note)?errors.note:null"
                  @input="removeError('note')"
                  @change="updateRequest('note', $event)"
                  :loading="isRequestingNow.includes('note')"
                ></v-text-field>
              </v-col>
              <v-col
                v-if="isCreation"
                cols="12"
                class="text-right pt-3"
              >
                <v-btn
                  @click.prevent="createItem"
                  type="submit" color="primary" :loading="pageLoading"
                > {{$t('general.create')}}
                </v-btn>
              </v-col>
              <v-col
                v-if="!isCreation"
                cols="12"
                class="pt-3 "
              >
                <div class="d-flex">
                  <div>
                    <div>
                      <span>{{$t('general.balance')}}: <b>{{(item.balance/100).toFixed(2)}}</b></span>
                    </div>
                    <div>
                      <span>{{$t('general.defect')}}: <b>{{(item.defect/100).toFixed(2)}}</b></span>
                    </div>
                  </div>
                  <div class="ml-auto">
                    <v-btn
                      color="green"
                      dark
                      fab
                      small
                      @click="isShowIncomeDialog = true"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    <v-btn
                      color="red"
                      class="ml-2"
                      dark
                      fab
                      small
                      @click="isShowExpenseDialog = true"
                    >
                      <v-icon>mdi-minus</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row class="mt-5">
              <v-col cols="12">
                <div v-if="paginatedObject.data && paginatedObject.data.length">
                  <table class="tableStockEvents">
                    <tr>
                      <th>{{$t('table.headers.type')}}</th>
                      <th>{{$t('table.headers.counter')}}</th>
                      <th>{{$t('table.headers.note')}}</th>
                      <th>{{$t('table.headers.date')}}</th>
                    </tr>
                    <tr :key="event.id" v-for="event in paginatedObject.data">
                      <template v-if="event.type === 'income'">
                        <td>{{$t('warehouse.income')}}</td>
                        <td>{{(event.amount/100).toFixed(2)}}</td>
                        <td>{{event.note}}</td>
                        <td>
                          <div>{{ $t('general.date') }}:
                            {{moment.utc(event.created_at).local().format(DATETIME_VIEW)}} <small
                              v-if="event.data.user">({{ event.data.user.name }})</small>
                          </div>
                          <div>{{ $t('general.price') }}: {{(event.data.price/100).toFixed(2)}}</div>
                        </td>
                      </template>
                      <template v-if="event.type === 'expense'">
                        <td>{{$t('warehouse.expense')}}</td>
                        <td>{{(event.amount/100).toFixed(2)}}</td>
                        <td>{{event.note}}</td>
                        <td>
                          <div>{{ $t('general.date') }}:
                            {{moment.utc(event.created_at).local().format(DATETIME_VIEW)}} <small
                              v-if="event.data.user">({{ event.data.user.name }})</small>
                          </div>
                          <div>{{$t('warehouse.recipient') }}:
                            <router-link
                              :to="{ name: 'stock-item.show.by_cleaner', params: { uuid: event.data.cleaner.uuid }}">
                              {{ event.data.cleaner.name }}
                            </router-link>

                          </div>
                        </td>
                      </template>
                      <template v-if="event.type === 'reject'">
                        <td>{{ $t('general.defect') }}</td>
                        <td>{{(event.amount/100).toFixed(2)}}</td>
                        <td>{{event.note}}</td>
                        <td>
                          <div>{{ $t('general.date') }}:
                            {{moment.utc(event.created_at).local().format(DATETIME_VIEW)}} <small
                              v-if="event.data.user">({{ event.data.user.name }})</small>
                          </div>
                        </td>
                      </template>
                      <template v-if="event.type === 'revoke'">
                        <td>{{ $t('warehouse.writeoff_defect') }}</td>
                        <td>{{(event.amount/100).toFixed(2)}}</td>
                        <td>{{event.note}}</td>
                        <td>
                          <div>{{ $t('general.date') }}:
                            {{moment.utc(event.created_at).local().format(DATETIME_VIEW)}} <small
                              v-if="event.data.user">({{ event.data.user.name }})</small>
                          </div>
                        </td>
                      </template>
                    </tr>
                  </table>
                </div>
              </v-col>
              <v-col cols="12" v-if="!isCreation">
                <pagination-listing
                  :pagination-data="paginationData"
                  @go-prev="changePage('-')"
                  @go-next="changePage('+')"
                ></pagination-listing>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
        <edit-modal-stock-income
          :stock-item="item"
          :item="currentEditableItem"
          :is-show-dialog="isShowIncomeDialog"
          @on-close="onCloseDialog"
          @on-action="onActionDialog"
        />
        <edit-modal-stock-expense
          :stock-item="item"
          :item="currentEditableItem"
          :is-show-dialog="isShowExpenseDialog"
          @on-close="onCloseDialog"
          @on-action="onActionDialog"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';
import i18n from '@/i18n';
// import messages from '@/lang/ru';
import updatePageContentMixin from '@/mixins/updatePageContentMixin';
import validationMixin from '@/mixins/validationMixin';
import regionsFilter from '@/mixins/filters/regionsFilter';
import StockItemProxy from '@/proxies/Stock/StockItemProxy';
import EditModalStockIncome from '@/components/listings/EditModalStockIncome.vue';
import EditModalStockExpense from '@/components/listings/EditModalStockExpense.vue';
import { prepareValidationMessages } from '@/utils';
import paginationMixin from '@/mixins/listing/paginationMixin';
import PaginationListing from '@/components/listings/PaginationListing.vue';
import { PER_PAGE_ORDERS } from '@/constants/listing';
import { DATETIME_VIEW } from '@/constants/dates';

export default {
  name: 'StoreItemShow',
  mixins: [
    updatePageContentMixin,
    validationMixin,
    regionsFilter,
    paginationMixin,
  ],
  components: {
    EditModalStockIncome,
    EditModalStockExpense,
    PaginationListing,
  },
  data() {
    return {
      moment,
      DATETIME_VIEW,
      isCreation: true,
      pageLoading: false,
      shouldSeeLoaderOnUpdating: true,
      isShowIncomeDialog: false,
      isShowExpenseDialog: false,
      useNullableRegion: false,
      isRequestingNow: [],
      item: {
        region: 'kyiv',
        measure: 'unit',
      },
      errors: {},
      updatingData: {},
      currentEditableItem: {},
      measureItems: [],
      searchParams: {
        page: {
          number: 1,
          size: PER_PAGE_ORDERS,
        },
      },
    };
  },
  created() {
    this.pageLoading = true;
    const items = [];

    const curLocale = i18n.locale;
    const { messages } = i18n;

    _.forEach(messages[curLocale].enums.measure, (value, key) => {
      items.push({
        text: value,
        value: key,
      });
    });
    this.measureItems = items;
    this.fetchData();
  },
  watch: {
    '$route.params.item': {
      handler() {
        this.fetchData();
      },
    },
    searchParams: {
      handler() {
        this.fetchEventsData();
      },
      deep: true,
    },
  },
  methods: {
    fetchData() {
      if (this.$route.params.item === 'new') {
        this.isCreation = true;
        this.pageLoading = false;
        this.$store.dispatch('page/finishUpdateCurrentPageContent');
      } else {
        this.isCreation = false;
        new StockItemProxy().find(this.$route.params.item)
          .then((response) => {
            this.fetchEventsData();
            this.item = response.data.data.item;
            return Promise.resolve(this.item);
          })
          .catch((error) => {
            console.error(error);
            /* return this.$router.push({
                                name: 404,
                              }); */
          })
          .finally(() => {
            this.pageLoading = false;
            this.$store.dispatch('page/finishUpdateCurrentPageContent');
          });
      }
    },
    fetchEventsData() {
      new StockItemProxy()
        .setParameters(this.searchParams)
        .amountListing(this.$route.params.item)
        .then((response) => {
          this.paginatedObject = response.data.data.items;
          this.$forceUpdate();
        })
        .catch((error) => {
          console.warn(error);
          this.paginatedObject = {};
        })
        .finally(() => {
          this.isTableLoading = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
    updateRequest(property, val) {
      if (!this.pageLoading && !this.isCreation) {
        this.isRequestingNow.push(property);
        (this.updateSimpleRequest(this.item, property))(val)
          .catch((response) => {
            this.errors = prepareValidationMessages(response.data.data);
          })
          .finally(() => {
            const index = this.isRequestingNow.indexOf(property);
            if (index !== -1) this.isRequestingNow.splice(index, 1);
          });
      }
    },
    updateSimpleRequest(item, property) {
      return (value) => {
        const data = {};
        data[property] = value;
        this.updatingData[item.id] = true;
        this.$forceUpdate();
        return new StockItemProxy().update(item.id, data)
          .then((response) => {
            item[property] = response.data.data.item[property];
          })
          .finally(() => {
            delete this.updatingData[item.id];
            this.$forceUpdate();
          });
      };
    },
    createItem() {
      if (this.$refs.form.validate()) {
        this.pageLoading = true;
        new StockItemProxy().create({
          name: this.item.name,
          note: this.item.note,
          measure: this.item.measure,
          region: this.item.region,
        })
          .then((response) => {
            if (response.data.data.item.id) {
              this.item = {};
              this.$router.push({
                name: 'stock-item.show',
                params: { item: response.data.data.item.id },
              });
            } else {
              console.error(response);
            }
          })
          .catch((error) => {
            console.error(error);
            this.errors = prepareValidationMessages(error.data.data);
          })
          .finally(() => {
            this.pageLoading = false;
            this.$store.dispatch('page/finishUpdateCurrentPageContent');
          });
      }
    },
    onCloseDialog(item) {
      this.isShowIncomeDialog = false;
      this.isShowExpenseDialog = false;
    },
    onActionDialog(item) {
      this.fetchData();
      this.onCloseDialog();
    },
  },
};
</script>

<style scoped lang="scss">
  .tableStockEvents {
    width: 100%;
    border-spacing: 0;

    th {
      border: 1px solid #dddddd;
    }

    td {
      border: 1px solid #dddddd;
    }
  }
</style>
